module.exports = __webpack_public_path__ + "e5b79c2f9cfd6a76c6a36be81b55dd24.jpg";